var React = require('react');

function MenuOpen (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"1","x2":"27","y2":"1","stroke":"black","strokeWidth":"2","key":0}),React.createElement("line",{"y1":"11","x2":"27","y2":"11","stroke":"black","strokeWidth":"2","key":1})]);
}

MenuOpen.defaultProps = {"width":"27","height":"12","viewBox":"0 0 27 12","fill":"none"};

module.exports = MenuOpen;

MenuOpen.default = MenuOpen;
